// GSAP Stagger animation
function setupStaggerAnimation() {
  const staggerEl = document.querySelector(".stagger");
  if (staggerEl) {
    gsap.from(".stagger > *", {
      autoAlpha: 0,
      y: 30,
      stagger: 0.05,
      duration: 0.5,
      delay: 0.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: ".stagger",
        start: "top 80%",
      },
    });
  }
}

// Parallax/Floating Image animation (GSAP)
function setupImageParallax() {
  document
    .querySelectorAll(".image-text-image-wrapper img")
    .forEach((img, i) => {
      const isOpposite = i === 1; // second image only

      gsap.fromTo(
        img,
        {
          y: 70,
          rotation: isOpposite ? 4 : -4,
        },
        {
          y: -70,
          rotation: isOpposite ? 12 : -12,
          ease: "none",
          scrollTrigger: {
            trigger: img,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        }
      );
    });
}

const observer = new MutationObserver(() => {
  const el = document.querySelector(".shopify-pc__banner__dialog");
  if (el) {
    gsap.fromTo(
      el,
      { autoAlpha: 0, y: 40 },
      { autoAlpha: 1, y: 0, duration: 0.6, delay: 6, ease: "power2.out" }
    );
    observer.disconnect();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Index page initial load timeline (GSAP)
function setupIndexPageTimeline() {
  if (!document.body.classList.contains("index")) return;

  const tl = gsap.timeline({ delay: 1 });

  tl.fromTo(
    ".header",
    { autoAlpha: 0, y: -5 },
    { duration: 1, autoAlpha: 1, y: 0, ease: "power3.out" }
  );
  tl.fromTo(
    ".hero-title",
    { autoAlpha: 0, y: 15 },
    { duration: 1.2, autoAlpha: 1, y: 0, ease: "power3.out" },
    "-=0.8"
  )
    .fromTo(
      ".hero-buttons",
      { autoAlpha: 0, y: 15 },
      { duration: 0.8, autoAlpha: 1, y: 0, ease: "power3.out" },
      "-=1.1"
    )
    .fromTo(
      ".hero-marquee-container",
      { height: 0, autoAlpha: 0 },
      { duration: 1.2, height: "auto", autoAlpha: 1, ease: "power3.out" },
      "=0"
    );
}

// Use white header text only while the header sits over the hero.
function toggleHeaderMenuInvert() {
  const header = document.querySelector("header");
  const heroOverlay = document.querySelector(".hero-overlay, .header-media-wrapper");
  const menuItems = document.querySelectorAll(
    ".header__inline-menu, .header__icon, .header__heading-logo-wrapper, .header__icons .button--secondary"
  );

  if (!header || !heroOverlay || !menuItems.length) return;

  const updateColors = () => {
    const headerBounds = header.getBoundingClientRect();
    const heroBounds = heroOverlay.getBoundingClientRect();
    const headerCenter = headerBounds.top + headerBounds.height / 2;
    const overHero = headerCenter >= heroBounds.top && headerCenter < heroBounds.bottom;

    menuItems.forEach((item) => {
      item.classList.toggle("invert", overHero);
    });
  };

  let frame = 0;
  const scheduleUpdate = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      updateColors();
    });
  };

  window.addEventListener("scroll", scheduleUpdate, { passive: true });
  window.addEventListener("resize", scheduleUpdate);
  window.addEventListener("load", scheduleUpdate);
  const observer = new ResizeObserver(scheduleUpdate);
  observer.observe(header);
  observer.observe(heroOverlay);
  updateColors();
}

// Handling hover states for 'details' elements in the menu (for dropdowns)
function setupHeaderMenuHover() {
  const inlineMenu = document.querySelector(".header__inline-menu");
  if (!inlineMenu) return;

  const items = inlineMenu.querySelectorAll("details");
  const hoverPointer = window.matchMedia("(hover: hover) and (pointer: fine)");

  items.forEach((item) => {
    const summary = item.querySelector(":scope > summary");
    let closeTimer;

    item.addEventListener("pointerenter", (event) => {
      if (!hoverPointer.matches || event.pointerType === "touch") return;
      clearTimeout(closeTimer);
      item.open = true;
    });

    item.addEventListener("pointerleave", (event) => {
      if (!hoverPointer.matches || event.pointerType === "touch") return;
      closeTimer = setTimeout(() => {
        item.open = false;
      }, 200);
    });

    summary.addEventListener("click", (event) => {
      // Mouse clicks must not toggle a menu already controlled by hover.
      // Touch taps and keyboard activation keep the native details behavior.
      if (hoverPointer.matches && event.pointerType !== "touch" && event.detail > 0) {
        event.preventDefault();
        summary.setAttribute("aria-expanded", item.open);
      }
    });

    item.addEventListener("toggle", () => {
      summary.setAttribute("aria-expanded", item.open);
    });
  });
}

// Handle header inversion when mega menu is opened/closed
function setupMegaMenuToggleInversion() {
  const logo = document.querySelector(".header__heading-logo-wrapper");
  const icons = document.querySelectorAll(".header__icon");
  const megaMenus = document.querySelectorAll(".mega-menu");

  if ((!logo && icons.length === 0) || megaMenus.length === 0) return;

  const toggleInvertClass = (add) => {
    const action = add ? "add" : "remove";
    if (logo) logo.classList[action]("mega-open");
    icons.forEach((icon) => icon.classList[action]("mega-open"));
  };

  megaMenus.forEach((menu) => {
    menu.addEventListener("toggle", () => {
      toggleInvertClass(menu.hasAttribute("open"));
    });
  });
}

// Initialize Instagram feed slider after images are loaded
function initializeInstaFeedSlider() {
  const wrapperSelector = "#insta-feed .instafeed-new-layout-wrapper";

  // Wait until the wrapper exists
  const wrapperObserver = new MutationObserver(() => {
    const feedWrapper = document.querySelector(wrapperSelector);
    if (!feedWrapper) return;

    wrapperObserver.disconnect();

    // Now wait for lazy images to get their real src attributes
    waitForLazyImages(feedWrapper);
  });

  wrapperObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function waitForLazyImages(feedWrapper) {
  const lazySelector = ".instafeed-lazy-image";

  const checkImages = () => {
    const imgs = feedWrapper.querySelectorAll(lazySelector);
    if (imgs.length === 0) return false;

    return Array.from(imgs).every(
      (img) =>
        img.getAttribute("src") &&
        img.getAttribute("src").trim() !== "" &&
        !img.getAttribute("src").includes("placeholder")
    );
  };

  // If already loaded, proceed immediately
  if (checkImages()) {
    buildSlider(feedWrapper);
    return;
  }

  // Observe changes to attributes in the feed wrapper
  const imgObserver = new MutationObserver(() => {
    if (checkImages()) {
      imgObserver.disconnect();
      buildSlider(feedWrapper);
    }
  });

  imgObserver.observe(feedWrapper, {
    attributes: true,
    subtree: true,
    attributeFilter: ["src"],
  });
}

function buildSlider(feedWrapper) {
  const sliderWrapper = document.createElement("div");
  sliderWrapper.classList.add("insta-slider-wrapper");

  const sliderTrack = document.createElement("div");
  sliderTrack.classList.add("insta-slider-track");

  feedWrapper.parentNode.insertBefore(sliderWrapper, feedWrapper);
  sliderWrapper.appendChild(sliderTrack);
  sliderTrack.appendChild(feedWrapper);

  const clone1 = feedWrapper.cloneNode(true);
  sliderTrack.appendChild(clone1);
}

// Accordion animation
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector("summary");
    this.content =
      el.querySelector(".content") ||
      (() => {
        // fallback: wrap everything except summary
        const wrapper = document.createElement("div");
        wrapper.className = "content";
        while (el.children.length > 1) {
          wrapper.appendChild(el.children[1]);
        }
        el.appendChild(wrapper);
        return wrapper;
      })();
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    );
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) {
      this.animation.cancel();
    }

    if (!this.prefersReducedMotion.matches) {
      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    } else {
      this.onAnimationFinish(false);
    }
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${
      this.summary.offsetHeight + this.content.offsetHeight
    }px`;

    if (this.animation) {
      this.animation.cancel();
    }

    if (!this.prefersReducedMotion.matches) {
      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: "ease-out",
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    } else {
      this.onAnimationFinish(true);
    }
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = "";
    this.el.style.overflow = "";
  }
}

document.querySelectorAll(".product__accordion details").forEach((el) => {
  new Accordion(el);
});

document.addEventListener("DOMContentLoaded", () => {
  // GSAP Animations
  setupStaggerAnimation();
  setupImageParallax();
  setupIndexPageTimeline();

  // Header/Menu Logic
  toggleHeaderMenuInvert();
  setupHeaderMenuHover();
  setupMegaMenuToggleInversion();
});

window.addEventListener("load", () => {
  initializeInstaFeedSlider();
});
